import { genPopulateAttr } from '@utils/util';

export const peopleCardAttributes = (): string => {
  const attributes = [['image'], ['link'], ['job_category']];
  return attributes.map(it => genPopulateAttr(it)).join('&');
};
